import { CustomerSubscriptionItem } from "./CustomerSubscription.item";
import { OOMenuItemNutritionalInformation } from "./menu-item-nutritional-information.model";
import { OOCanvas } from "./oo-canvas";
import { OOCanvasMenuItem } from "./oo-canvas-menu-item.model";
import { OOMenuItemCanvas } from "./oo-menu-item-canvas.model";
import { OOMenuItemTags } from "./oo-menu-tags.model";
import { OOCanvasMenuItemTimeRange } from "./OOCanvasMenuItemTimeRange.entity";

export class OOMenuItem {
	menuItemKey: number;
	name: string;
	menuItemId: string;
	price: number;
	price2: number;
	price3: number;
	price4: number;
	price5: number;
	price6: number;
	priceLevel: number;
	priceLevelEnforced: boolean;
	priceNumber: number;
	priceNumberName: string;
	priceSub: number;
	priceExtra: number;
	priceMod: number;
	priceNo: number;
	online: boolean;
	taxable: boolean;
	description: string;

	cost: null;
	deleted: boolean;
	guestCheckName: string;
	modUnit: number;
	pk: string;
	reportGroupId: number;
	sk: string;
	venueKey: number;

	displayName: string;
	sortOrder: number;
	canvases: OOCanvas[];
	// canvases: OOMenuItemCanvas[];
	valid?: boolean;
	outOfStock: boolean;
	countdown: boolean;
	imageKey: string;
	imageUrl: string;
	kioskImageKey: string;
	lastUpdated: string;
	subscriptionAvailable: boolean;
	subscriptionItem: boolean;
	subscriptionPriceNumber: number;
	subscriptionCountMax: number;
	subscriptionAllowedFrequencies: number[];
	nutritionalInformation: OOMenuItemNutritionalInformation[];

	subscriptions: CustomerSubscriptionItem[];

	available: boolean;
	unavailableMessage: string;

	quickAdd: boolean; // set in onlineorder component for front end

	OOMenuItemTags?: OOMenuItemTags[];

	ooCanvasMenuItems: OOCanvasMenuItem[];

	ooMenuItemCanvases: OOMenuItemCanvas[];

	OOCanvasMenuItemTimeRange: OOCanvasMenuItemTimeRange[];

	public constructor(init?: Partial<OOMenuItem>) {
		Object.assign(this, init);
	}
}
